module.exports = __webpack_public_path__ + "static/media/Logo.f619a8f8.png";